module.exports = __webpack_public_path__ + "static/img/14000653.1c966f90.png";